import $ from 'jquery';

/**
 * @param {object} selectors
 * @param {array} wrapperSelector - a jQuery object
 * @returns {object}
 */
const querySelectors = (selectors, wrapperSelector = []) => {
    const $$ = {};
    const $wrapperEl = $(wrapperSelector);
    const $wrapper = $wrapperEl.length > 0 ? $wrapperEl : $('body');

    $$.el = $wrapper;

    $.each(selectors, function (key, value) {
        $$[key] = $(value, $wrapper);
    });

    return $$;
};

export default querySelectors;


// WEBPACK FOOTER //
// ./src/js/utils/querySelectors.js